import * as Types from '../actions/ActionTypes';

const itemDetails = {
    data: {},
    pageName: null,
    insertDisabled: false,
    updateDisabled: false,
    inputField: [],
    isLoading: true
};

const initialState = {
    tableListing: {
        pageNotFound: false,
        title: null,
        total: 10,
        rowsPerPage: 10,
        filters: {},
        page: 0,
        pages: 1,
        sort: 'asc',
        field: 'id',
        column: [{ title: null, name: null, }],
        data: [],
        setting: {
            regions: []
        },
        pageName: null,
        insertDisabled: false,
        updateDisabled: false,
        deleteDisabled: false,
        resetEnabled: false,
        verifyEnabled: false,
        submitLeadEnabled: false,
        customItemDetailsPage: false,
        filterDateEnabled: false,
        filterGeneralSearchDisabled: false,
        filterRegionSearchEnabled: false,
        filterRegionSearchAllEnabled: false,
        importEnabled: false,
        itemDetails,
        isLoading: true
    }
}

const TableListingReducer = function (state = initialState, action) {
    switch (action.type) {
        case Types.GET_TABLE_LISTING_PENDING: {
            return {
                ...state,
                tableListing: {
                    ...initialState.tableListing,
                    isLoading: true
                },
            }
        }
        case Types.GET_TABLE_LISTING_SUCCESS: {
            return {
                ...state,
                tableListing: {
                    itemDetails,
                    ...action.payload,
                    isLoading: false
                },
            }
        }

        case Types.GET_TABLE_LISTING_FAILED: {
            return {
                ...state,
                tableListing: {
                    ...initialState.tableListing,
                    pageNotFound: true,
                    isLoading: false
                },
            }
        }
        case Types.GET_ITEM_DETAILS_PENDING: {
            return {
                ...state,
                tableListing: {
                    ...initialState.tableListing,
                    isLoading: true
                },
            }
        }
        case Types.GET_ITEM_DETAILS_SUCCESS: {
            return {
                ...state,
                tableListing: {
                    ...state.tableListing,
                    itemDetails: action.payload,
                    isLoading: false
                },
            }
        }
        case Types.GET_ITEM_DETAILS_FAILED: {
            return {
                ...state,
                tableListing: {
                    ...initialState.tableListing,
                    isLoading: false
                },
            }
        }
        case Types.UPDATE_TABLE_LISTING: {
            return {
                ...state,
                tableListing: {
                    ...action.payload,
                    isLoading: false
                },
            }
        }
        case Types.UPDATE_ITEM_DETAILS: {
            return {
                ...state,
                tableListing: {
                    ...initialState.tableListing,
                    itemDetails: action.payload,
                    isLoading: false
                },
            }
        }
        case Types.UPDATE_ITEM_DETAILS_SUCCESS: {
            return {
                ...state,
                tableListing: {
                    ...state.tableListing,
                    itemDetails: {
                        ...state.tableListing.itemDetails,
                        data: action.payload,
                    },
                    isLoading: false
                },
            }
        }
        case Types.IMPORT_ITEM_DETAILS_SUCCESS: {
            return {
                ...state,
            }
        }
        default: {
            return {
                ...state,
            }
        }
    }
}

export default TableListingReducer
